import { axiosInstance } from '@configs/axios/axiosInstance';

import type { Organization } from '../types/organization.types';

/**
 * Fetch available organizations for current user
 * Endpoint: GET /users/organizations
 */
export async function fetchOrganizations(): Promise<Organization[]> {
  const { data } = await axiosInstance.get<Organization[]>(
    '/users/organizations'
  );
  return data;
}
